module.exports = __webpack_public_path__ + "img/gn.c341accb.svg";